module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/bg_testi-33841fc1b19a4177f93d6062966c487c.png";